import axiosInstance from ".";

export const getIndustrial = () => {
  return axiosInstance.get("/industrial");
};

export const updateIndustrial = (data) => {
  return axiosInstance.post("/industrial", data);
};
